export default __webpack_public_path__ + "static/media/Logo_Mediline_Color_Positivo_vertical.0c930381.jpg";